import React, { ReactNode, useEffect, useRef, useCallback } from 'react';
import { useToast } from '@cko/primitives';
import {
  ClientModel,
  EntityModel,
  SegmentModel,
  useCurrentClientManager,
} from '@cko/dashboard-shared';

interface AccountChangedNotificationProps {
  children?: ReactNode;
}

export const AccountChangedNotification = ({ children }: AccountChangedNotificationProps) => {
  const defaultsLoaded = useRef<boolean>(false);
  const { showToast } = useToast();

  const { client, entity, segment, selectedAccountLevel } = useCurrentClientManager();
  const setDefaultsLoaded = useCallback(() => {
    if (client && client.id) {
      defaultsLoaded.current = true;
    }
  }, [client]);

  useEffect(() => {
    if (defaultsLoaded.current) {
      let accountSelected: ClientModel | EntityModel | SegmentModel | undefined;

      if (selectedAccountLevel === 'client') {
        accountSelected = client;
      }
      if (selectedAccountLevel === 'entity') {
        accountSelected = entity;
      }
      if (selectedAccountLevel === 'segment') {
        accountSelected = segment;
      }

      if (accountSelected) {
        showToast(`View switched to ${accountSelected.name}`);
      }
    }
    setDefaultsLoaded();
  }, [client, entity, segment, selectedAccountLevel, setDefaultsLoaded]);

  return <>{children}</>;
};
